<template>
  <div class="center-top-box">
    <div class="center-item" v-for="(item,index) in tempArr" :key="item.key">
      <span class="center-item-title" :class="'bg-'+index">
        <countTo :startVal='0' :endVal='item.title' :duration='10000'></countTo>
        <em class="hb-num" :class="'cols-'+index">{{item.unit}}</em>
      </span>
      <p class="center-item-des" :class="'col-'+index">
        <a :href="index>0?'/indexmacro?id='+(index):'/prosperity'" target="_blank" title="点击查看细则" :class="'cols-'+index">{{item.count}}</a>
      </p>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to';
export default {
  name: "center-top",
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    countTo
  },
  data () {
    return {
      tempArr:[{
        title: 97,
        count: '行业景气度',
        unit: '环比：0.12%',
        key: '1'
      },{
        title: 88,
        count: '负荷指数',
        unit: '环比：-0.17%',
        key: '2'
      },{
        title: 20,
        count: '库存指数',
        unit: '环比：1.31%',
        key: '3'
      },{
        title: 5424,
        count: '价格指数',
        unit: '环比：-10.1%',
        key: '4'
      }]
    }
  },
  mounted () {
    let $this=this;
    $this.getindexOverview()
    $this.dataRefresh.$ons('Refresh',()=>{
      $this.getindexOverview()
    })
  },
  methods:{
    getindexOverview(){
      let $this=this;
      const url = '/api-portal/ccf/industryMonitoring/indexOverview';
      this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          let arr=[]
          for(var i=0;i<datas.length-1;i++){
            let indexName=datas[i].indexName||''
            let avgMonthly=parseFloat((datas[i].indexes[0].avgMonthly||0).toFixed(2))
            let sequentialGrowth=parseFloat(datas[i].indexes[0].sequentialGrowth||0)
            let da={}
            da['title']=avgMonthly
            da['count']=indexName
            da['unit']='环比：'+(sequentialGrowth*100).toFixed(2)+'%'
            da['key']=i
            arr.push(da)
          }
          const tpnum=parseFloat(datas[4]?(datas[4].indexes[0].avgMonthly || 6523) : 6523)
          $this.$emit('totalcapacity',tpnum)
          $this.tempArr=arr
        }
      },'json');
    }
  }
}
</script>

<style scoped>
.center-top-box {
  display: flex;
  margin-top: 30px;
  position: relative;
  z-index: 25;
  width: 800px;
  margin-left: 80px;
}
.center-item{
  width: 126px;
  color: #fff;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 25%;
  margin: 0 15px;
}
.center-item-title {
  font-size: 36px;
  width: 120px;
  height: 130px;
  padding-top: 10px;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  flex-wrap: wrap;
}
.center-item-des {
  display: inline-block;
  margin-top: 15px;
  font-size: 16px;
  padding: 11px 0px;
  width: 79%;
  text-align: center;
  cursor: pointer;
  font-family: "fzskjt";
}

.center-item-des:hover{
  text-shadow: 2px 3px 3px rgba(0,0,0,.8);
  background-color: rgba(255,255,255,.1);
}

.center-item-des a{
  text-decoration: none;
}

.hb-num{
  display: block;
  width: 120px;
  font-size: 14px;
  line-height: 26px;
  font-style: normal;
}

.center-item-unit {
  margin-left: 5px;
  font-size: 12px;
}
.bg-0 {
  background: url("../../../assets/1.fw.png");
  background-size: 100% 100%;
}
.bg-1 {
  background: url("../../../assets/2.fw.png");
  background-size: 100% 100%;
}
.bg-2 {
  background: url("../../../assets/3.fw.png");
  background-size: 100% 100%;
}
.bg-3 {
  background: url("../../../assets/4.fw.png");
  background-size: 100% 100%;
}
.col-0{
  color: #36E7DE;
  background: url("../../../assets/1-1.fw.png");
  background-size: 100% 100%;
}
.col-1 {
  color: #FEE052;
  background: url("../../../assets/2-1.fw.png");
  background-size: 100% 100%;
}
.col-2{
  color: #9FD2F9;
  background: url("../../../assets/3-1.fw.png");
  background-size: 100% 100%;
}
.col-3{
  color: #E8ADFE;
  background: url("../../../assets/4-1.fw.png");
  background-size: 100% 100%;
}

.cols-0{
  color: #34E5DE;
}
.cols-1{
  color: #FEDF52;
}
.cols-2{
  color: #2095EF;
}
.cols-3{
  color: #CA46FC;
}
</style>



// WEBPACK FOOTER //
// src/views/HomeManage/module/center-top.vue